import { createSlice } from '@reduxjs/toolkit';
import { storage as secureStorage } from '../../utils/helpers';

const initialState = {
  username: secureStorage.getItem('username'),
  full_name: secureStorage.getItem('full_name'),
  access_token: secureStorage.getItem('access_token'),
  isAuthenticated: !!secureStorage.getItem('access_token'),
  isLoading: false,
  error: null,
  permissions: secureStorage.getItem('role') ? JSON.parse(secureStorage.getItem('role')).permissions || [] : [],
  role: secureStorage.getItem('role') ? JSON.parse(secureStorage.getItem('role')) : null,
  id: secureStorage.getItem('id'),
  district: secureStorage.getItem('district') === 'null' || secureStorage.getItem('district') === null ? null : secureStorage.getItem('district'),
  subdivision: secureStorage.getItem('subdivision') === 'null' || secureStorage.getItem('subdivision') === null ? null : secureStorage.getItem('subdivision'),
  block: secureStorage.getItem('block') === 'null' || secureStorage.getItem('block') === null ? null : secureStorage.getItem('block'),
  
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    loginStart: (state) => {
      state.isLoading = true;
      state.error = null;
    },
    loginSuccess: (state, action) => {
      state.isLoading = false;
      state.isAuthenticated = true;
      state.username = action.payload.username;
      state.full_name = action.payload.full_name;
      state.access_token = action.payload.access_token;
      state.permissions = action.payload.role.permissions || [];
      state.role = action.payload.role;
      state.id = action.payload.id;
      state.district = action.payload.district;
      state.subdivision = action.payload.subdivision;
      state.block = action.payload.block;
      
      // Store in secureStorage
      secureStorage.setItem('access_token', action.payload.access_token);
      secureStorage.setItem('username', action.payload.username);
      secureStorage.setItem('full_name', action.payload.full_name);
      secureStorage.setItem('role', JSON.stringify(action.payload.role));
      secureStorage.setItem('id', action.payload.id);
      secureStorage.setItem('district', action.payload.district);
      secureStorage.setItem('subdivision', action.payload.subdivision);
      secureStorage.setItem('block', action.payload.block);
    },
    loginFailure: (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
      state.isAuthenticated = false;
      state.username = null;
      state.full_name = null;
      state.access_token = null;
      state.permissions = [];
      state.role = null;
      state.id = null;
      state.district = null;
      state.subdivision = null;
      state.block = null;
    },
    logout: (state) => {
      state.isAuthenticated = false;
      state.username = null;
      state.full_name = null;
      state.access_token = null;
      state.permissions = [];
      state.role = null;
      state.id = null;
      state.district = null;
      state.subdivision = null;
      state.block = null;
      state.error = null;
      
      // Clear secureStorage
      secureStorage.clear();
    },
    clearError: (state) => {
      state.error = null;
    },
    setPermissions: (state, action) => {
      state.permissions = action.payload;
    },
  },
});

export const {
  loginStart,
  loginSuccess,
  loginFailure,
  logout,
  clearError,
  setPermissions,
} = authSlice.actions;

export default authSlice.reducer;
